<template lang="html">
  <div id="user-access-page">

    <section class="container access-section">
      <div class="row">
        <div class="col-md-9 col-lg-7 col-xl-6 col-content">
          <p class="p-logo">
            <img src="public/images/grupo-oz.png" alt="Grupo OZ">
          </p>

          <h5 class="title">Recuperar contraseña</h5>

          <div class="box-info">
            <p>
              Escribe tu correo en el formulario. Te enviaremos un mensaje con los pasos necesarios para recuperar tu acceso.
            </p>
          </div>

          <b-form @submit="onSubmit">
            <b-form-group class="form-group-s1"
              label="Correo electrónico">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder="Escribe tu correo electrónico"
                required
              ></b-form-input>
            </b-form-group>

            <p class="mb-4 text-right">
              <router-link class="f-w-700 f-s-1-05 txt-red" to="/">¿Recuerdas tu contraseña? Accede</router-link>
            </p>

            <div class="d-block">
              <b-button type="submit" class="w-100 btn-s1 bg-red btn-lg">Recuperar acceso</b-button>
            </div>
          </b-form>
        </div>
      </div>
      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
       
      </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showpass: false,

      form: {
        email: null,
        password: null,
      },
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Cargando...';
      this.$refs.modal.open();
      axios.post(tools.url("/api/resetpassword"),this.form).then((response)=>{
          this.modal.block = false;
          this.modal.icon = 'success';
          this.modal.msg = 'Se ha enviado un correo electrónico con la información';
      }).catch((error)=>{
        console.log(error);
          this.modal.block = false;
          this.modal.icon = 'error';
          //this.$root.handleErrors(error)  ;
          this.modal.msg = this.$root.handleErrors(error);
      });
    },
  },

  watch:{
    'showpass':function (val) {
        if (val == true) {
          $("#il-1").prop('type','text');
        }
        else if (val == false) {
          $("#il-1").prop('type','password');
        }
    },
  },
}
</script>
